/* Rebuilt cart behaviour.
   Rules for anyone editing this file:
   - No setInterval, no MutationObserver, no polling of any kind.
     A previous version polled /cart.js every 2s and took the store down.
   - Every network call is triggered by a direct user action, once.
   - Every DOM lookup is guarded; nothing here may break the checkout form.
   - All copy comes from section settings via data-* attributes on the root. */
(function(){
  'use strict';

  /* ---------- money ---------- */
  function formatMoney(cents, format){
    var value = typeof cents === 'number' ? cents : parseInt(cents, 10);
    if (isNaN(value)) value = 0;
    var fmt = (format && format.indexOf('{{') !== -1) ? format : '{{amount}}';

    function build(precision, thousands, decimal){
      var fixed = (value / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(match, name){
      switch (name){
        case 'amount': return build(2, ',', '.');
        case 'amount_no_decimals': return build(0, ',', '');
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', '');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return build(0, ' ', '');
        case 'amount_with_space_separator': return build(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return build(2, ' ', '.');
        default: return build(2, ',', '.');
      }
    });
  }

  function setMoney(el, cents, format){
    if (!el) return;
    var html = formatMoney(cents, format);
    if (html.indexOf('<') !== -1){ el.innerHTML = html; } else { el.textContent = html; }
  }

  function init(root){
    if (!root || root.__crtInit) return;
    root.__crtInit = true;

    var busy = false;
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var lastTotal = parseInt(root.getAttribute('data-cart-total-cents'), 10);
    if (isNaN(lastTotal)) lastTotal = null;

    function txt(name, fallback){
      var v = root.getAttribute(name);
      return (v === null || v === '') ? (fallback || '') : v;
    }

    /* Locale-aware URLs. The store publishes more than one locale, so a hard
       '/cart/change.js' would 404 or drop the locale on /en/cart. */
    function url(path){
      var base = txt('data-routes-root', '/');
      if (base.charAt(base.length - 1) !== '/') base += '/';
      return base + String(path).replace(/^\//, '');
    }

    function controls(){
      return root.querySelectorAll('[data-qty-minus],[data-qty-plus],[data-remove],[data-discount-apply]');
    }

    function setBusy(state, li){
      busy = !!state;
      var nodes = controls();
      for (var i = 0; i < nodes.length; i++){ nodes[i].disabled = !!state; }
      if (li && li.classList) li.classList.toggle('is-updating', !!state);
    }

    /* ---------- rendering ---------- */
    function renderEmpty(){
      var wrap = root.querySelector('.crt__wrap');
      if (!wrap) return;
      var box = document.createElement('div');
      box.className = 'crt__empty';

      var title = document.createElement('h1');
      title.className = 'crt__title';
      title.textContent = txt('data-txt-title');

      var msg = document.createElement('p');
      msg.className = 'crt__empty-txt';
      msg.textContent = txt('data-txt-empty');

      var link = document.createElement('a');
      link.className = 'crt__cta crt__cta--link';
      link.setAttribute('href', txt('data-collections-url', '/collections/all'));
      link.textContent = txt('data-txt-continue');

      box.appendChild(title);
      box.appendChild(msg);
      box.appendChild(link);
      wrap.innerHTML = '';
      wrap.appendChild(box);
    }

    function renderDiscountRows(cart){
      var list = root.querySelector('.crt__totals');
      var anchor = root.querySelector('[data-cart-subtotal-row]');
      if (!list || !anchor) return;

      var old = list.querySelectorAll('[data-cart-discount-row]');
      for (var i = 0; i < old.length; i++){ old[i].parentNode.removeChild(old[i]); }

      var apps = cart && cart.cart_level_discount_applications ? cart.cart_level_discount_applications : [];
      for (var j = 0; j < apps.length; j++){
        var row = document.createElement('li');
        row.className = 'crt__totals-row crt__totals-row--discount';
        row.setAttribute('data-cart-discount-row', '');

        var label = document.createElement('span');
        label.textContent = apps[j].title || '';

        var amount = document.createElement('span');
        amount.textContent = '-' + formatMoney(apps[j].total_allocated_amount, moneyFormat).replace(/<[^>]*>/g, '');

        row.appendChild(label);
        row.appendChild(amount);
        list.insertBefore(row, anchor);
      }
    }

    /* Single source of truth: whatever /cart/change.js or /cart.js returned.
       Quantities are read back from the response, so an inventory clamp
       (asked for 5, only 3 in stock) shows the real number, not the tap count. */
    function applyCart(cart){
      if (!cart) return;

      if (typeof cart.total_price === 'number') lastTotal = cart.total_price;
      root.setAttribute('data-cart-total-cents', String(cart.total_price));

      if (cart.item_count === 0){ renderEmpty(); updateCounts(cart); return; }

      var items = cart.items || [];
      var byKey = {};
      for (var i = 0; i < items.length; i++){
        byKey[items[i].key] = items[i];
        items[i].__line = i + 1;
      }

      var rows = root.querySelectorAll('.crt__item');
      for (var r = 0; r < rows.length; r++){
        var row = rows[r];
        var item = byKey[row.getAttribute('data-key')];
        if (!item){
          if (row.parentNode) row.parentNode.removeChild(row);
          continue;
        }
        row.setAttribute('data-line', String(item.__line));

        var qtyEl = row.querySelector('[data-qty-val]');
        if (qtyEl) qtyEl.textContent = item.quantity;

        setMoney(row.querySelector('[data-line-price]'), item.final_line_price, moneyFormat);

        var wasEl = row.querySelector('[data-line-price-was]');
        if (wasEl){
          if (item.original_line_price > item.final_line_price){
            setMoney(wasEl, item.original_line_price, moneyFormat);
            wasEl.removeAttribute('hidden');
          } else {
            wasEl.setAttribute('hidden', '');
          }
        }
      }

      setMoney(root.querySelector('[data-cart-subtotal]'), cart.items_subtotal_price, moneyFormat);
      setMoney(root.querySelector('[data-cart-total]'), cart.total_price, moneyFormat);
      renderDiscountRows(cart);
      updateCounts(cart);
    }

    function updateCounts(cart){
      var inSection = root.querySelector('[data-crt-count]');
      if (inSection) inSection.textContent = '(' + cart.item_count + ')';
      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++){ badges[i].textContent = cart.item_count; }
    }

    /* ---------- quantity: in-place, no reload ---------- */
    root.addEventListener('click', function(e){
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      var btn = target.closest('[data-qty-minus],[data-qty-plus],[data-remove]');
      if (!btn || !root.contains(btn)) return;

      e.preventDefault();
      if (busy) return;

      var li = btn.closest('.crt__item');
      if (!li) return;
      var key = li.getAttribute('data-key');
      if (!key) return;

      var valEl = li.querySelector('[data-qty-val]');
      var current = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
      var next = current;
      if (btn.hasAttribute('data-qty-minus')) next = Math.max(0, current - 1);
      if (btn.hasAttribute('data-qty-plus')) next = current + 1;
      if (btn.hasAttribute('data-remove')) next = 0;
      if (next === current) return;

      setBusy(true, li);
      fetch(url('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function(res){
        if (!res.ok) throw new Error('change failed');
        return res.json();
      }).then(function(cart){
        setBusy(false, li);
        applyCart(cart);
      }).catch(function(){
        /* fallback only: never leave the cart showing a stale number */
        window.location.reload();
      });
    });

    /* ---------- discount: apply for real, report the truth ---------- */
    function showMsg(text, ok){
      var el = root.querySelector('[data-discount-msg]');
      if (!el) return;
      el.textContent = text || '';
      el.classList.toggle('crt__discount-msg--ok', !!ok);
      el.classList.toggle('crt__discount-msg--bad', !ok && !!text);
    }

    function codeAccepted(cart, code){
      var codes = (cart && cart.discount_codes) || [];
      var wanted = String(code).toUpperCase();
      for (var i = 0; i < codes.length; i++){
        if (String(codes[i].code).toUpperCase() === wanted) return codes[i].applicable === true;
      }
      return false;
    }

    function applyDiscount(){
      var input = root.querySelector('[data-discount-input]');
      var code = input && input.value ? input.value.trim() : '';

      if (!code){
        showMsg(txt('data-msg-discount-empty'), false);
        if (input) input.focus();
        return;
      }
      if (busy) return;

      var before = lastTotal;
      setBusy(true, null);
      showMsg('', false);

      fetch(url('discount/' + encodeURIComponent(code)), {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function(){
        return fetch(url('cart.js'), {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
      }).then(function(res){
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      }).then(function(cart){
        applyCart(cart);
        var cartLevel = !!(cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
        var totalMoved = (typeof before === 'number' && typeof cart.total_price === 'number' && cart.total_price !== before);
        var accepted = cartLevel || totalMoved || codeAccepted(cart, code);
        showMsg(accepted ? txt('data-msg-discount-ok') : txt('data-msg-discount-bad'), accepted);
      }).catch(function(){
        showMsg(txt('data-msg-error'), false);
      }).then(function(){
        setBusy(false, null);
      });
    }

    var discountForm = root.querySelector('[data-discount-form]');
    if (discountForm){
      discountForm.addEventListener('submit', function(e){
        e.preventDefault();
        applyDiscount();
      });
    }
  }

  function boot(){
    var roots = document.querySelectorAll('[data-cart-rebuilt]');
    for (var i = 0; i < roots.length; i++){ init(roots[i]); }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
